// src/app/core/services/theme.service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly STORAGE_KEY = 'ts-theme';
    private readonly DARK_CLASS = 'app-dark';

    isDark = signal(true); // dark por defecto

    constructor() {
        this.init();
    }

    private init(): void {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        // Si no hay valor guardado, dark es el default
        const dark = stored !== null ? stored === 'dark' : true;

        this.isDark.set(dark);
        this.applyClass(dark);
    }

    toggle(): void {
        const next = !this.isDark();

        this.isDark.set(next);
        this.applyClass(next);
        localStorage.setItem(this.STORAGE_KEY, next ? 'dark' : 'light');
    }

    private applyClass(dark: boolean): void {
        const el = document.documentElement;

        if (dark) {
            el.classList.add(this.DARK_CLASS);
        } else {
            el.classList.remove(this.DARK_CLASS);
        }
    }
}
